const PROFILE_PREFIX = '@PROFILE';

export const LOGIN = `${PROFILE_PREFIX}/LOGIN`;
export const LOGIN_SUCCESS = `${PROFILE_PREFIX}/LOGIN_SUCCESS`;
export const LOGIN_ERROR = `${PROFILE_PREFIX}/LOGIN_ERROR`;

export const LOGOUT = `${PROFILE_PREFIX}/LOGOUT`;
export const LOGOUT_SUCCESS = `${PROFILE_PREFIX}/LOGOUT_SUCCESS`;
export const LOGOUT_ERROR = `${PROFILE_PREFIX}/LOGOUT_ERROR`;

export const FETCH = `${PROFILE_PREFIX}/FETCH`;
export const FETCH_SUCCESS = `${PROFILE_PREFIX}FETCH_SUCCESS`;
export const FETCH_ERROR = `${PROFILE_PREFIX}FETCH_ERROR`;

export const FETCH_BALANCE = `${PROFILE_PREFIX}/FETCH_BALANCE`;
export const FETCH_BALANCE_SUCCESS = `${PROFILE_PREFIX}/FETCH_BALANCE_SUCCESS`;
export const FETCH_BALANCE_ERROR = `${PROFILE_PREFIX}/FETCH_BALANCE_ERROR`;

export const SET_IS_USING_DEFAUL_PIN = `${PROFILE_PREFIX}/SET_IS_USING_DEFAUL_PIN`;

export const SET_LOGIN_DATA = `${PROFILE_PREFIX}/SET_LOGIN_DATA`;
